export default {"src":"/_next/static/media/xstate.69bfbed4.svg","height":33,"width":104};